import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncablePriceListFacilityFragment = { readonly __typename?: 'SyncablePriceListFacility', readonly id: string, readonly organisationId: string, readonly priceListId?: string | null, readonly linkedOrganisationPriceListId?: string | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } };

export type SyncPriceListFacilityPullQueryVariables = Types.Exact<{
  input: Types.PullPriceListFacilityInput;
}>;


export type SyncPriceListFacilityPullQuery = { readonly __typename?: 'Query', readonly pullPriceListFacility: { readonly __typename?: 'PullPriceListFacilityResult', readonly checkpoint?: { readonly __typename?: 'SyncableCheckpoint', readonly id: string, readonly updatedAt: string } | null, readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncablePriceListFacility', readonly id: string, readonly organisationId: string, readonly priceListId?: string | null, readonly linkedOrganisationPriceListId?: string | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export const WholeSyncablePriceListFacilityFragmentDoc = gql`
    fragment WholeSyncablePriceListFacility on SyncablePriceListFacility {
  id
  organisationId
  priceListId
  linkedOrganisationPriceListId
  meta {
    createdAt
    createdByUserId
    updatedAt
    updatedByUserId
    deleted
  }
}
    `;
export const SyncPriceListFacilityPullDocument = gql`
    query SyncPriceListFacilityPull($input: PullPriceListFacilityInput!) {
  pullPriceListFacility(input: $input) {
    checkpoint {
      id
      updatedAt
    }
    documents {
      ...WholeSyncablePriceListFacility
    }
  }
}
    ${WholeSyncablePriceListFacilityFragmentDoc}`;

/**
 * __useSyncPriceListFacilityPullQuery__
 *
 * To run a query within a React component, call `useSyncPriceListFacilityPullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncPriceListFacilityPullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncPriceListFacilityPullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncPriceListFacilityPullQuery(baseOptions: Apollo.QueryHookOptions<SyncPriceListFacilityPullQuery, SyncPriceListFacilityPullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncPriceListFacilityPullQuery, SyncPriceListFacilityPullQueryVariables>(SyncPriceListFacilityPullDocument, options);
      }
export function useSyncPriceListFacilityPullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncPriceListFacilityPullQuery, SyncPriceListFacilityPullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncPriceListFacilityPullQuery, SyncPriceListFacilityPullQueryVariables>(SyncPriceListFacilityPullDocument, options);
        }
export type SyncPriceListFacilityPullQueryHookResult = ReturnType<typeof useSyncPriceListFacilityPullQuery>;
export type SyncPriceListFacilityPullLazyQueryHookResult = ReturnType<typeof useSyncPriceListFacilityPullLazyQuery>;
export type SyncPriceListFacilityPullQueryResult = Apollo.QueryResult<SyncPriceListFacilityPullQuery, SyncPriceListFacilityPullQueryVariables>;